export const controlCodeList = [
    'SA09009', 'SA09010', 'SA09012', 'SA09013',
    'SA09024', 'SA09025', 'SA09026', 'SA09027', 'SA09028', 'SA09029',
    'SA09066', 'SA09067', 'SA09068'];

export const amountCodeList = [
    'SA_origAllowances', 'SA_origAllowances_001', 'SA_origAllowances_002',
    'SA_TotalTaxAmount', 'SA_TotalTaxAmount3', 'SA_TotalTaxAmount5', 'SA_TotalTaxAmount6'];


export const settlementError = ['EXWF0001','SA_MB00008','SA_MB00011','SA_MB00018','SA_MB00004'];

export const otherError = ['UA_Common_Biz_Voucher_204'];